export const API_URL = process.env.REACT_APP_API_URL ?? "http://127.0.0.1:5000";
export const FRONTEND_URL =
  process.env.REACT_APP_FRONTEND_URL ?? "http://127.0.0.1:3000";
